import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExplore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="m7.446 8.718-4.035 2.804a.51.51 0 0 0-.154.679l.497.86a.513.513 0 0 0 .664.207l.01-.005 4.497-1.996a.513.513 0 0 0 .217-.715l-.963-1.667a.513.513 0 0 0-.733-.167m-.851-1.235a2.013 2.013 0 0 1 2.883.652l.963 1.667a2.013 2.013 0 0 1-.878 2.823l-.009.004-4.5 1.998a2.013 2.013 0 0 1-2.599-.816l-.497-.86a2.01 2.01 0 0 1 .601-2.663zm4.084 9.371-.983-1.751-1.4.594-.577 1.157zm-3.21-2.435a.8.8 0 0 0-.398.374l-1.208 2.42a.79.79 0 0 0 .706 1.14h5.325a.79.79 0 0 0 .687-1.174l-1.889-3.366a.79.79 0 0 0-.995-.34l-2.229.946Zm7.332-10.655a.933.933 0 0 0-1.386-.266L11.5 5.008a.93.93 0 0 0-.23 1.2l1.602 2.774a.93.93 0 0 0 1.154.4l2.264-.901a.933.933 0 0 0 .463-1.334zM12.485 2.32a2.433 2.433 0 0 1 3.615.693l1.953 3.383a2.433 2.433 0 0 1-1.207 3.477l-2.264.902a2.43 2.43 0 0 1-3.008-1.044L9.972 6.957a2.43 2.43 0 0 1 .6-3.126z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExplore;
